import { render, staticRenderFns } from "./tpl-edit.vue?vue&type=template&id=3710a262&scoped=true"
import script from "./tpl-edit.vue?vue&type=script&lang=js"
export * from "./tpl-edit.vue?vue&type=script&lang=js"
import style0 from "./tpl-edit.vue?vue&type=style&index=0&id=3710a262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3710a262",
  null
  
)

export default component.exports